import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { DashboardDataEntryModel } from "src/app/model/DashboardDataEntryModel";
import { Page } from "src/app/model/Page";
import { QueryExecutorModel } from "src/app/model/QueryExecutorModel";
import { DashboardDataEntryService } from "src/app/services/dashboardDataEntry.service";
import { ReportService } from "src/app/services/report.service";

@Component({
  selector: "app-secure-dashboard-dataentry-list",
  templateUrl: "./dashboard-dataentry-list.component.html",
  styleUrls: ["./dashboard-dataentry-list.component.scss"],
})
export class DashboardDataentryListComponent implements OnInit, AfterViewInit {
  queryExecutorList: Page<DashboardDataEntryModel>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<DashboardDataEntryModel> = new MatTableDataSource();
  displayedColumns: string[] = [
    "id",
    "headerName",
    "generationDate",
    // "reportDescription",
    "board",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;

  constructor(
    private router: Router,
    private reportService: ReportService,
    private dashboardDataEntryService: DashboardDataEntryService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.loadData();
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.required, Validators.minLength(3)])
    });
  }

  onSearch() {
    if (this.filterForm.valid) {
      this.loadData();
    }
    else {
      this._snackBar.open("Please enter Filter text (minimum - 3 char)", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isSearchDisabled = false;
    }
  }

  resetFilter() {
    this.filterForm.controls['filterText'].setValue(null);
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    console.log('this.filterForm.value', this.filterForm.value, this.filterForm.value?.filterText, 
    this.filterForm.value?.filterText !== undefined);
    this.dashboardDataEntryService.fetchDashboardList(this.currentPage, this.pageSize, 
      this.filterForm.value?.filterText != undefined ? 
      this.filterForm.value?.filterText
      : null
      ).subscribe((page) => {
        this.isLoading = false;
        console.log(page);
        this.queryExecutorList = page;
        this.dataSource = new MatTableDataSource(page.content);
        setTimeout(() => {
          this.paginator.pageIndex = this.currentPage;
          this.paginator.length = page.totalElements;
        });
        this.isSearchDisabled = false;
      },
      (error) => {
        console.log(error);
        this.isLoading = false;
        this.isSearchDisabled = false;
      }
    );
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }

  deactivate(key: number) {
    if(confirm("Do you want to De-Activate the Daily Dashboard Report")) {
      this.reportService.toggleActivationQueryExecutor(key, 'N').subscribe((data: any)=>{
        if(data.status === 'SUCCESS') {
          let selectedObj = this.queryExecutorList.content.find(o => o.key === key);
          selectedObj.activeFlag = 'N';
          this.reportService.successToast('Query Executor de-activated successfully');
        }
        else {
          this.reportService.errorToast(data.errorMessage);
        }
      });
    } 
  }
 
  activate(key: number) {
    if(confirm("Do you want to Activate the Query Executor")) {
      this.reportService.toggleActivationQueryExecutor(key, 'Y').subscribe((data: any)=>{
        if(data.status === 'SUCCESS') {
          let selectedObj = this.queryExecutorList.content.find(o => o.key === key);
          selectedObj.activeFlag = 'Y';
          this.reportService.successToast('Query Executor activated successfully');
        }
        else {
          this.reportService.errorToast(data.errorMessage);
        }
      });
    } 
  }
}